import React, { useEffect, useState } from "react";
import JumboRqList from "@jumbo/components/JumboReactQuery/JumboRqList";
import JumboListToolbar from "@jumbo/components/JumboList/components/JumboListToolbar";
import ButtonGroup from "@mui/material/ButtonGroup";
import {
  Button,
  Card,
  Dialog,
  DialogContent,
  DialogTitle,
  useMediaQuery,
} from "@mui/material";
import { useParams } from "react-router-dom";
import JumboSearch from "@jumbo/components/JumboSearch";
import ListIcon from "@mui/icons-material/List";
import ViewComfyIcon from "@mui/icons-material/ViewComfy";
import { USE_IMAGE_PLACEHOLDERS } from "../../../utils/constants/paths";
import Item from "./Item";
import JumboContentLayout from "@jumbo/components/JumboContentLayout";
import Header from "./header";
import Sidebar from "./sidebar";
import { ParentProvider, useParentContext } from "./context";
import { useJumboTheme } from "@jumbo/hooks";
import Stack from "@mui/material/Stack";
import FolderDropdown from "./FolderDropdown";
import { useAppMutation } from "../../../services";
import adminServices from "../../../services/admin-services";
import ParentForm from "./ParentForm";
import { useTranslation } from "react-i18next";
import ChildInfoForm from "./ChildInfoForm";
import PurchaseInfo from "./PurchaseInfo";
import ReservationInfo from "./ReservationInfo";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";

export const ASSET_IMAGES = process.env.REACT_APP_IMAGES_PATH;

export const ASSET_AVATARS = ASSET_IMAGES + "/avatar";

export const getAssetPath = (url, size) => {
  if (USE_IMAGE_PLACEHOLDERS) {
    return `https://via.placeholder.com/${size}.png`;
  }

  return url;
};

const BulkActions = () => {
  return <>Bulk Action</>;
};

const Children = () => {
  return (
    <ParentProvider>
      <InnerChildren />
    </ParentProvider>
  );
};

const InnerChildren = () => {
  const {
    mutate: mLoadTeachers,
    error,
    isError,
    data,
    isSuccess,
  } = useAppMutation(adminServices.loadParents);
  const { theme } = useJumboTheme();
  const { globalState, setGlobalState } = useParentContext();
  const { t } = useTranslation();
  //const {globalState, setGlobalState} = useProgramsContext();
  const lg = useMediaQuery(theme.breakpoints.down("lg"));
  // const {mutate,error,isError, data,isSuccess} = useAppMutation(authServices.adminSignIn);

  const loadParent = async ({ queryKey }) => {
    const { page, limit: size, queryParams } = queryKey[1];
    const result = await adminServices.loadParents({
      page: page + 1,
      size,
      search: queryParams?.keywords,
    });

    console.log("queryKey", page, size, queryKey, result);
    return { parents: result.parents, count: result.totalRecords };
  };

  const layoutOptions = React.useMemo(
    () => ({
      sidebar: {
        sx: {
          [theme.breakpoints.up("lg")]: {
            position: "sticky",
            zIndex: 5,
            top: 96,
            minHeight: "auto",
          },
          [theme.breakpoints.down("lg")]: {
            display: "none",
          },
        },
      },
      wrapper: {
        sx: {
          alignItems: "flex-start",
        },
      },
    }),
    [theme],
  );
  const params = useParams();
  const listRef = React.useRef();
  // const {refreshContactsList, setContactsListRefresh, setSelectedContacts} = useContactsApp();

  const [refreshContactsList, setContactsListRefresh] = useState(true);
  const [selectedContacts, setSelectedContacts] = useState();

  const [view, setView] = React.useState("list");

  const [queryOptions, setQueryOptions] = React.useState({
    queryKey: "parents",
    queryParams: { category: params.category, id: params.id },
    countKey: "count",
    dataKey: "parents",
  });

  useEffect(() => {
    if (globalState?.refreshList) {
      listRef.current.refresh();
      setGlobalState({ ...globalState, refreshList: false });
    }
  }, [globalState]);

  React.useEffect(() => {
    setQueryOptions((state) => ({
      ...state,
      queryParams: {
        ...state.queryParams,
        category: params.category,
        id: params.id,
      },
    }));
  }, [params]);

  const renderParent = React.useCallback(
    (parent) => {
      return <Item parent={parent} view={view} />;
    },
    [view],
  );

  React.useEffect(() => {
    if (refreshContactsList) {
      listRef.current.refresh();
      setContactsListRefresh(false);
    }
  }, [refreshContactsList]);

  const handleOnChange = React.useCallback((keywords) => {
    setQueryOptions((state) => ({
      ...state,
      queryParams: { ...state.queryParams, keywords: keywords },
    }));
  }, []);

  return (
    <JumboContentLayout
      layoutOptions={layoutOptions}
      sidebar={<Sidebar />}
      header={
        <Header
          title={t("admin-parent.title.title")}
          subheader={t("admin-parent.title.subheader")}
        />
      }
    >
      {lg && (
        <Stack spacing={2} direction={"row"} sx={{ mb: 3, mt: -2 }}>
          {/*<FolderDropdown/>*/}
        </Stack>
      )}
      <JumboRqList
        ref={listRef}
        wrapperComponent={Card}
        primaryKey={"parentId"}
        queryOptions={queryOptions}
        itemsPerPage={10}
        itemsPerPageOptions={[10, 15, 20, 50, 100]}
        renderItem={renderParent}
        service={loadParent}
        componentElement={"div"}
        sx={view === "grid" && { p: (theme) => theme.spacing(1, 3, 3) }}
        wrapperSx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
        }}
        toolbar={
          <JumboListToolbar
            hideItemsPerPage={false}
            bulkActions={false}
            actionTail={
              <ButtonGroup
                variant="outlined"
                disableElevation
                sx={{
                  "& .MuiButton-root": {
                    px: 1,
                  },
                }}
              >
                <Button
                  variant={view === "list" ? "contained" : "outlined"}
                  onClick={() => setView("list")}
                >
                  <ListIcon />
                </Button>
                <Button
                  variant={view === "grid" ? "contained" : "outlined"}
                  onClick={() => setView("grid")}
                >
                  <ViewComfyIcon />
                </Button>
              </ButtonGroup>
            }
          >
            <JumboSearch
              onChange={handleOnChange}
              sx={{
                display: { xs: "none", md: "block" },
              }}
            />
          </JumboListToolbar>
        }
        view={view}
      />
      <Dialog
        fullWidth
        open={globalState.openAddEdit}
        onClose={() =>
          setGlobalState((prev) => ({ ...prev, openAddEdit: false }))
        }
      >
        <DialogTitle>
          {t("admin-parent.title.updateDetails")}
          <IconButton
            aria-label="close"
            onClick={() =>
              setGlobalState((prev) => ({ ...prev, openAddEdit: false }))
            }
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ width: "100%" }}>
          <ParentForm />
        </DialogContent>
      </Dialog>
      <Dialog fullWidth open={globalState.openChildInfo}>
        {/*<DialogTitle>{t("Child Info")}</DialogTitle>*/}
        <DialogContent sx={{ width: "100%" }}>
          <ChildInfoForm />
        </DialogContent>
      </Dialog>
      {/*<Dialog fullWidth open={globalState.openPurchaseInfo}>
        <DialogTitle>{t("Purchases Info")}</DialogTitle>
        <DialogContent sx={{ width: "100%" }}>
          <PurchaseInfo />
        </DialogContent>
      </Dialog>*/}
      <Dialog
        open={globalState.openPurchaseInfo}
        fullWidth
        maxWidth="md"
        onClose={() =>
          setGlobalState((prev) => ({ ...prev, openPurchaseInfo: false }))
        }
        PaperProps={{
          sx: {
            borderRadius: "12px", // adjust as needed (10/12/16)
            overflow: "hidden", // keeps header/divider corners clean
          },
        }}
      >
        <DialogContent sx={{ width: "100%" }}>
          <PurchaseInfo />
        </DialogContent>
      </Dialog>

      <Dialog fullWidth open={globalState.openReservationInfo}>
        <DialogTitle>{t("Reservation Info")}</DialogTitle>
        <DialogContent sx={{ width: "100%" }}>
          <ReservationInfo />
        </DialogContent>
      </Dialog>
    </JumboContentLayout>
  );
};

export default Children;
